export default {
  pageTitle: "关于哔咔动漫",
  pageDesc: "了解哔咔动漫的品牌故事、平台口碑与联系方式",
  brand: {
    title: "品牌介绍",
    subtitle: "让漫画触手可及",
    paragraph1: "哔咔动漫成立于2019年，是国内领先的免费漫画在线阅读平台。我们始终坚持「漫画应该属于每一个人」的理念，致力于打破付费壁垒，为漫画爱好者打造一个完全免费、内容丰富、体验流畅的综合漫画阅读社区。",
    paragraph2: "平台覆盖日漫、韩漫、国漫三大品类，收录了数千部热门与经典漫画作品。无论是热血战斗、浪漫恋爱、奇幻冒险还是悬疑推理，在哔咔动漫你都能找到心仪的作品。我们采用先进的下拉式阅读技术，让阅读漫画像呼吸一样自然。",
    paragraph3: "作为哔咔漫画免费观看的官方入口，我们始终将用户体验放在首位。不断优化阅读性能、丰富内容库、提升更新速度，只为让你享受到最纯粹的漫画阅读乐趣。",
  },
  reputation: {
    title: "用户口碑",
    subtitle: "来自百万用户的声音",
  },
  contact: {
    title: "联系我们",
    subtitle: "有任何建议或合作意向，欢迎随时联系",
    email: "电子邮箱",
    wechat: "微信公众号",
    qq: "QQ群号",
    formTitle: "给我们留言",
    namePlaceholder: "您的昵称",
    emailPlaceholder: "您的邮箱",
    messagePlaceholder: "请输入您的留言内容（不超过500字）",
    submit: "提交留言",
    success: "感谢您的留言，我们会尽快回复！",
    error: "提交失败，请稍后重试。",
    formName: "哔咔动漫留言表单",
  },
};